import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// Import a function which adds the web components to the window
import { platformBrowser } from '@angular/platform-browser';
import { defineCustomElements as defineCustomUpsElements } from '@ux/components/loader';

// Register the UPS web components
defineCustomUpsElements(window);


if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
